import React from "react";
import { AUTOPILOT_COLORS } from "../../../components/autopilot/styles";

// Pills de status reutilizáveis entre Minhas Transportadoras (H1), Catálogo
// (H2) e o Detalhe/drawer (H3) — PO1-2620. Mesmos tokens de cor já usados em
// views/Admin/Transportadoras/VinculoConectorTab.jsx (statusSuccess*/statusWarning*/
// statusDanger*), sem paleta nova.
const TONES = {
  ativo: {
    bg: AUTOPILOT_COLORS.statusSuccessBg,
    border: AUTOPILOT_COLORS.statusSuccessBorder,
    color: AUTOPILOT_COLORS.statusSuccess,
    label: "Ativo",
  },
  pendente: {
    bg: AUTOPILOT_COLORS.insetSurface,
    border: AUTOPILOT_COLORS.statusWarning,
    color: AUTOPILOT_COLORS.statusWarning,
    label: "Pendente",
  },
  erro_credencial: {
    bg: AUTOPILOT_COLORS.statusDangerBg,
    border: AUTOPILOT_COLORS.statusDangerBorder,
    color: AUTOPILOT_COLORS.statusDanger,
    label: "Erro de credencial",
  },
  "sem-conector": {
    bg: AUTOPILOT_COLORS.insetSurface,
    border: AUTOPILOT_COLORS.border,
    color: AUTOPILOT_COLORS.muted,
    label: "Sem conector",
  },
  // PO1-3856: categoria do conector no card do Catálogo (Agregador, E-commerce,
  // app, API da transportadora, pelo sistema). Tom informativo discreto.
  categoria: {
    bg: AUTOPILOT_COLORS.insetSurface,
    border: AUTOPILOT_COLORS.statusInfo,
    color: AUTOPILOT_COLORS.statusInfo,
    label: "Conector",
  },
};

const pillStyle = (tone) => ({
  display: "inline-flex",
  alignItems: "center",
  fontSize: "0.72rem",
  padding: "2px 8px",
  borderRadius: 10,
  whiteSpace: "nowrap",
  background: tone.bg,
  color: tone.color,
  border: `1px solid ${tone.border}`,
});

// status: 'ativo' | 'pendente' | 'erro_credencial' | 'sem-conector' | 'categoria'
export function StatusPill({ status, labelOverride }) {
  const tone = TONES[status] || TONES.pendente;
  return <span style={pillStyle(tone)}>{labelOverride || tone.label}</span>;
}

// Uma capacidade da matriz (ex.: { codigo: 'cap_cotacao', descricao: 'Cotação
// automática', status: 'ativo' }), como vem de GET /transportadoras/:id/capacidades.
export function CapacidadeBadge({ codigo, descricao, status }) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      <span style={{ fontSize: "0.78rem", color: AUTOPILOT_COLORS.text }}>{descricao || codigo}</span>
      <StatusPill status={status} />
    </span>
  );
}

// Bloco `sftp.cte`/`sftp.fatura` do snapshot de capacidades (H5). Sem
// embarcadorTemFlow, o "não configurado" vira o gancho comercial — nunca some,
// só muda a copy (decisão do kickoff PO1-2620).
export function SftpBadge({ configurado, semRecepcao, embarcadorTemFlow }) {
  if (!configurado) {
    return embarcadorTemFlow ? (
      <StatusPill status="pendente" labelOverride="Não configurado" />
    ) : (
      <StatusPill status="sem-conector" labelOverride="Ativar auditoria de frete" />
    );
  }
  return semRecepcao ? (
    <StatusPill status="pendente" labelOverride="Sem recepção" />
  ) : (
    <StatusPill status="ativo" labelOverride="Recebendo" />
  );
}

// Ciclo rascunho → vigência da tabela de frete (H3). Vigente=success,
// Rascunho=warning, Expirada=danger.
const VIGENCIA_STATUS = { Vigente: "ativo", Rascunho: "pendente", Expirada: "erro_credencial" };
export function VigenciaBadge({ estado }) {
  return <StatusPill status={VIGENCIA_STATUS[estado] || "pendente"} labelOverride={estado} />;
}
